(function(){
  var bars = document.querySelectorAll('.dr5-progress span');
  if (!bars.length) return;
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.style.transition = 'width 900ms cubic-bezier(.2,.8,.2,1)';
        io.unobserve(entry.target);
      }
    });
  }, {threshold:.3});
  bars.forEach(function(bar){io.observe(bar);});
})();
